import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import localeIT from '@angular/common/locales/it';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { RouterModule, Routes, ActivatedRoute } from '@angular/router';
import { FormComponent } from './components/form/form.component';
import { VerifyPhoneComponent } from './pages/verify-phone/verify-phone.component';
import { FormsModule } from '@angular/forms';
import { ApiService } from "./services/api.service";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { FormFinanceComponent } from './components/form-finance/form-finance.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { FormNltComponent } from './components/form-nlt/form-nlt.component';
import { CarCardComponent } from './components/car-card/car-card.component';
import { FormLoanComponent } from './components/form-loan/form-loan.component';
import { CurrencyMaskDirective } from './directives/currency-mask.directive';

import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { FormFinanceTopComponent } from './components/form-finance-top/form-finance-top.component';
import { FormRinnovoComponent } from './components/form-rinnovo/form-rinnovo.component';
import { FormUnicoComponent } from './components/form-unico/form-unico.component';
import { FormNltUnicoComponent } from './components/form-nlt-unico/form-nlt-unico.component';

registerLocaleData(localeIT, 'it');

const appRoutes: Routes = [
  { path: '', component: FormComponent,  data: { title: 'Parla con un esperto locale!' } },
  { path: 'finance', component: FormFinanceComponent,  data: { title: 'Richiedi un prestito' } },
  { path: 'finance-short', component: FormUnicoComponent,  data: { title: 'Richiedi un prestito' } },
  { path: 'finance-top', component: FormFinanceTopComponent,  data: { title: 'Richiedi un prestito' } },
  { path: 'rinnovo', component: FormRinnovoComponent,  data: { title: 'Rinnovo Cessione del Quinto' } },
  { path: 'NLT', component: FormNltComponent,  data: { title: 'Richiedi un preventivo' } },
  { path: 'NLT-short', component: FormNltUnicoComponent,  data: { title: 'Richiedi un preventivo' } },
  { path: 'loan', component: FormLoanComponent,  data: { title: 'Richiedi un preventivo' } },
  { path: 'verify/:id/:phone', component: VerifyPhoneComponent, data: { title: 'Verifica numero di telefono' } },
  { path: 'privacy/:id', component: PrivacyComponent, data: { title: 'Accetta la privacy' } }
];

export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: false,
  allowZero: false,
  decimal: ",",
  precision: 0,
  prefix: "",
  suffix: " ",
  thousands: ".",
  nullable: true
};

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    VerifyPhoneComponent,
    FormFinanceComponent,
    PrivacyComponent,
    FormNltComponent,
    CarCardComponent,
    FormLoanComponent,
    CurrencyMaskDirective,
    FormFinanceTopComponent,
    FormRinnovoComponent,
    FormUnicoComponent,
    FormNltUnicoComponent
  ],
  providers: [
    ApiService,
    { provide: LOCALE_ID, useValue: 'it' },
    CurrencyPipe, DecimalPipe 
  ],
  exports: [
    CurrencyMaskDirective
  ],
  imports: [
    NgbModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
